define('home/collections/MostLikedUserCollection',[
    'underscore',
    'core/api',
    'core/collections/PaginatedCollection',
    'core/UniqueModel',
    'home/models/User',
], function (
    _,
    api,
    PaginatedCollection,
    UniqueModel,
    User
) {
    'use strict';

    return PaginatedCollection.extend({

        initialize: function (_models, options) {
            this.forum = options.forum;  // forum is shortname/url string
        },

        model: UniqueModel.boundModel(User),
        url: api.getURL('forums/listMostLikedUsers'),

        fetch: function (options) {
            options = options || {};

            options.data = _.defaults({
                forum: this.forum,
                limit: 20,
            }, options.data);

            return PaginatedCollection.prototype.fetch.call(this, options);
        },

        parse: function () {
            var users = PaginatedCollection.prototype.parse.apply(this, arguments);
            _.each(users, function (user) {
                user.verb = 'topcommenter';
            });
            // Filter out users that have low reputation scores
            return _.filter(users, function (user) {
                if (parseFloat(user.rep) > 0.7)
                    return user;
            });
        },
    });
});

